<template>
    <a-spin :spinning="loading" tip="Carregando...">
        <a-table
            :columns="columns"
            :data-source="rows"
            :rowKey="row => row.id"
            :pagination="{ pageSize: 10 }"
            :rowSelection="rowSelection"
            size="small"
            bordered
        />
        <div class="footer">
            <a-space>
                <a-typography-text type="secondary" v-if="!internalSelectedIds.length">
                    Nenhum grupo selecionado.
                </a-typography-text>
                <a-button @click="$emit('cancel')">Fechar</a-button>
                <a-button
                    type="primary"
                    :disabled="!allowEmpty && internalSelectedIds.length === 0"
                    @click="emitSave"
                >
                    Salvar
                </a-button>
            </a-space>
        </div>
    </a-spin>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'

const props = defineProps({
    selectedIds: { type: Array, default: () => [] },
    endpoint:   { type: String, default: '/api/configurations/users-groups' },
    allowEmpty: { type: Boolean, default: true },
})
const emit = defineEmits(['save', 'cancel'])

const loading = ref(false)
const rows = ref([])

const selectedRowKeys = ref((props.selectedIds || []).map(Number))
const internalSelectedIds = computed(() => selectedRowKeys.value.map(Number))

const columns = [
    { title: 'ID',          dataIndex: 'id',         key: 'id',         width: 80,  sorter: (a,b)=>a.id-b.id },
    { title: 'Nome',        dataIndex: 'name',       key: 'name',       width: 220, sorter: (a,b)=>String(a.name).localeCompare(String(b.name)) },
    { title: 'Descrição',   dataIndex: 'description',key: 'description' },
]

const rowSelection = computed(() => ({
    type: 'checkbox',
    selectedRowKeys: selectedRowKeys.value,
    onChange: (keys) => { selectedRowKeys.value = keys.map(Number) },
}))

async function load() {
    try {
        loading.value = true
        const { data } = await window.axios.get(props.endpoint)
        rows.value = data?.data ?? data ?? []
    } finally {
        loading.value = false
    }
}

function emitSave () {
    emit('save', internalSelectedIds.value)
}

onMounted(async () => {
    await load()
    console.log(selectedRowKeys.value)

})

watch(() => props.selectedIds, (val) => {
    selectedRowKeys.value = (val || []).map(Number)
})
</script>

<style scoped>
.footer {
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-top: 12px;
}
</style>
